import {IAppState} from '@/interfaces/store-interfaces/app-state.interface';
import {ActionContext} from 'vuex';
import {Vue} from 'vue-property-decorator';
import {IState, RhizomeViewType} from "@/modules/Rhizome/interfaces/state.interface";
import {rhizomeResource} from "@/modules/Rhizome/resources/rhizome.resource";
import {Film} from "@/modules/Rhizome/interfaces/film.interface";
import {RouterStore} from "@/interfaces/store-interfaces/router-store.interface";
import ROUTE_NAME = RouterStore.ROUTE_NAME;

type StoreActionContext = ActionContext<IState, IAppState>;

export default {
  namespaced: true,

  state: {
    filmsList: [],
    viewType: RhizomeViewType.CLOUD,
    showFavorites: false,
    filterByKeyword: null,
    preActiveFilm: null,
    scaleCloud: 1,
    ordersFilmList: [],
    filterByKeywordName: '',
    errorOnRequest: false,
  },

  mutations: {
    setPropertyInState(state: IState, { name, value }: { name: string, value: any }) {
      Vue.set(state, name, value);
    },
  },

  actions: {
    async initRhizome({ state, commit }: StoreActionContext) {
      const keywordId = state.filterByKeyword ? state.filterByKeyword.id : null;
      const response: Film.IFilm[] = await rhizomeResource.getList(keywordId);
      commit('setPropertyInState', { name: 'filmsList', value: response });
    },

    async openRhizomeWithKeyword({ rootState, dispatch, commit }: StoreActionContext, { keyword }: { keyword: Film.IKeyword | null }) {
      commit('setPropertyInState', { name: 'filterByKeyword', value: keyword });
      await dispatch('routerStore/openPage', { routeName: ROUTE_NAME.RHIZOME_PAGE }, { root: true });
    },

    async openFilmOnRhizome({ rootState, dispatch, commit }: StoreActionContext, { filmId }: { filmId: number | null }) {
      commit('setPropertyInState', { name: 'preActiveFilm', value: filmId });
      await dispatch('routerStore/openPage', { routeName: ROUTE_NAME.RHIZOME_PAGE }, { root: true });
    },
  },
};
